<template>
  <div class="home">
    <section class="main">
      <!--收银-->
      <div class="cashier">
        <div class="cashier-header">
          <h2 class="cashier-title">{{$t('home.智慧零售 赋能门店')}}</h2>
          <p class="underline-red"><span></span></p>
        </div>
        <div class="cashier-main">
          <img class="cashier-img" src="../../assets/index/智慧零售赋能门店.jpg" alt="智慧零售赋能门店" height="560" width="800">
          <!--<span class="cashier-img"></span>-->
        </div>
      </div>

      <!--模块描述-->
      <div class="project-module">
        <div class="project-module-header">
          <h2 class="project-module-title">{{$t('home.为您提供新零售所需要的一切')}}</h2>
          <p class="underline-red"><span></span></p>
        </div>
        <div class="project-module-main">
          <ul class="module-box">
            <li>
              <div class="module-item">
                <img src="../../assets/index/销售退换货.png" alt="销售退换货">
                <p>{{$t('home.销售退换货')}}</p>
              </div>

              <div class="module-item">
                <img src="../../assets/index/预售-赠送.png" alt="预售-赠送">
                <p>{{$t('home.预售/赠送')}}</p>
              </div>

              <div class="module-item">
                <img src="../../assets/index/流行促销.png" alt="流行促销">
                <p>{{$t('home.流行促销')}}</p>
              </div>

              <div class="module-item">
                <img src="../../assets/index/预售-赠送.png" alt="预售-赠送">
                <p>{{$t('home.会员/积分')}}</p>
              </div>
            </li>

            <li>
              <div class="module-item">
                <img src="../../assets/index/储值-券.png" alt="储值-券">
                <p>{{$t('home.储值/券')}}</p>
              </div>

              <div class="module-item">
                <img src="../../assets/index/收发货.png" alt="收发货">
                <p>{{$t('home.收发货')}}</p>
              </div>

              <div class="module-item">
                <img src="../../assets/index/盘点.png" alt="盘点">
                <p>{{$t('home.盘点')}}</p>
              </div>

              <div class="module-item">
                <img src="../../assets/index/电商发货-退货.png" alt="电商发货-退货">
                <p>{{$t('home.电商发货/退货')}}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!--终端描述-->
      <div class="cashier-terminal">
        <div class="cashier-terminal-header">
          <h2 class="cashier-terminal-title">{{$t('home.真正的移动收银神器')}}</h2>
          <p style="text-align: center;color: #8A9096;margin-top: 8px;">{{$t('home.商米/PDA/平板/手机')}}</p>
          <p class="underline-red"><span></span></p>
        </div>
        <div class="cashier-terminal-main">
          <img class="cashier-terminal-main-img" src="../../assets/index/终端.png">
        </div>
      </div>

      <!--行业相关-->
      <div class="industry-module">
        <div class="industry-module-header">
          <h2 class="industry-module-title">{{$t('home.专为服饰零售行业客户而生')}}</h2>
          <p class="underline-red"><span></span></p>
        </div>
        <div class="industry-module-main">
          <ul class="module-box">
            <li>
              <div class="module-item">
                <img src="../../assets/index/女装.png" alt="女装">
              </div>

              <div class="module-item">
                <img src="../../assets/index/男装.png" alt="男装">
              </div>

              <div class="module-item">
                <img src="../../assets/index/童装.png" alt="童装">
              </div>
            </li>

            <li>
              <div class="module-item">
                <img src="../../assets/index/化妆品.png" alt="化妆品">
              </div>

              <div class="module-item">
                <img src="../../assets/index/鞋帽.png" alt="鞋帽">
              </div>

              <div class="module-item">
                <img src="../../assets/index/配饰.png" alt="配饰">
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!--关于我们-->
      <div class="about-us">
        <div class="about-us-header">
          <h2 class="about-us-title">{{$t('home.关于我们')}}</h2>
          <p class="underline-red"><span></span></p>
        </div>
        <div class="about-us-main">
          <p class="description">
            {{$t('home.广州丽晶软件科技股份有限公司致力做最杰出的服饰管理专家，着意创建先进、精简、实用高效的电脑信息管理系统，用专注、创新见证着中国服装产业信息化发展进程。丽晶不仅仅要让企业在标准化的行业体系之中占有一席之地，达到灵活调度企业资源，快速感知市场变化，准确规划运营策略，实现销售增长的目的，更要竭尽全力增强服饰企业本身的独特竞争力，指引应用者凭添果敢的能力，激发决策者闪现睿智的灵感，在现在和未来发展与竞争中不断超越！')}}
          </p>
          <ul class="module-box">
            <li>
              <div class="module-item">
                <img src="../../assets/index/工作理念.png" alt="工作理念">
              </div>

              <div class="module-item">
                <img src="../../assets/index/企业使命.png" alt="企业使命">
              </div>
            </li>

            <li>
              <div class="module-item">
                <img src="../../assets/index/价值理念.png" alt="价值理念">
              </div>

              <div class="module-item">
                <img src="../../assets/index/发展理念.png" alt="发展理念">
              </div>

            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="footer">
      <div class="footer-main">
        <div class="product">
          <h5 class=" item-title">{{$t('home.产品')}}</h5>
          <p>
            <router-link to="/index/price"></router-link>
          </p>
          <!--<p><a class="item-text">价钱</a></p>-->
          <p>
            <router-link to="/index/customer">{{$t('home.客户')}}</router-link>
          </p>
          <!--<p><a class="item-text">下载</a></p>-->
          <p>
            <router-link to="/index/download">{{$t('home.下载')}}</router-link>
          </p>
        </div>

        <div class="contact-us">
          <h5 class=" item-title">{{$t('home.联系我们')}}</h5>
          <p><span class="item-text">{{$t('home.全国热线')}} <span class="item-phone">400-888-5839</span></span></p>
          <p>
  <span class="item-text">
  <!--产品资讯-->
  <!--<span class="item-phone">400-888-5839</span>-->
  <div class="work-date">
  <span class="item-phone">（{{$t('home.周一至周五 9:00-18:00')}}）</span>
  </div>
  </span>
          </p>
          <p><span class="item-text">{{$t('home.公司邮箱')}} <span class="item-phone">service@regentsoft.com</span></span></p>
        </div>

        <div class="we-chat">
          <!--<h5 class=" item-title">{{$t('home.微信咨询')}}</h5>-->
          <img :src="qrcode[lang]" alt="">
          <!--<p class="item-text">{{$t('home.微信扫一扫')}}</p>-->
        </div>
      </div>
      <div class="site-info">
        <p>版权所有© 2011-2018 广州丽晶软件科技股份有限公司 <a target="_blank" href="https://beian.miit.gov.cn/">{{$t('home.粤ICP备12071402号')}}</a>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
  // import { vueLanguage } from '@/i18n/index.js'
  export default {
    name: 'home',
    data () {
      return {
        qrcode: {
          'en': require('../../assets/index/二维码en.png'),
          'zh-cn': require('../../assets/index/二维码.jpg'),
          'zh-hant': require('../../assets/index/二维码hant.png')
        },
        lang: window.localStorage.getItem('LOCALE_KEY')
      }
    },
    created() {
      this.lang = window.localStorage.getItem('LOCALE_KEY')
    }
  }
</script>

<style lang="scss" scoped>
  /*主页开始*/
  .home {
    &::-webkit-scrollbar{
      display: none;
    }
    font-size: 16px;
    .main {
      width: 900px;
      margin: 0 auto;
      text-align: center;
      // 公共样式
      h2 {
        margin: 0;
      }
      .underline-red {
        width: 100%;
        text-align: center;
        span {
          display: inline-block;
          width: 21px;
          height: 4px;
          border-bottom: 4px solid #FF587A;
        }
      }
      // 收银描述
      .cashier {
        padding-top: 80px;
        .cashier-header {
          .cashier-title {
            font-size: 32px;
            color: #2E3032;
          }
        }
        .cashier-main {
          margin-top: 33px;
          .cashier-img {
            display: inline-block;
            /*height: 380px;*/
          }
        }
      }

      // 项目模块描述
      .project-module {
        padding-top: 80px;
        .project-module-header {
          .project-module-title {
            font-size: 32px;
            color: #2E3032;
          }
        }
        .project-module-main {
          margin-top: 33px;
          color: #2E3032;
          .module-box {
            li {
              margin-bottom: 20px;
              &:last-child {
                margin-bottom: 0;
              }
              .module-item {
                display: inline-block;
                width: 180px;
                height: 100px;
                margin-right: 30px;
                img {
                  width: 40px;
                  height: 40px;
                }
                &:last-child {
                  margin-right: 0;
                }
              }
            }
          }
        }
      }

      // 终端描述
      .cashier-terminal {
        padding-top: 80px;
        .cashier-terminal-header {
          .cashier-terminal-title {
            font-size: 32px;
            color: #2E3032;
          }
        }
        .cashier-terminal-main {
          margin-top: 33px;
          .cashier-terminal-main-img {
            display: inline-block;
            width: 100%;
            background-color: #ccc;
          }
        }
      }

      // 行业相关
      .industry-module {
        padding-top: 80px;
        .industry-module-header {
          .industry-module-title {
            font-size: 32px;
            color: #2E3032;
          }
        }
        .industry-module-main {
          margin-top: 33px;
          color: #2E3032;
          .module-box {
            li {
              margin-bottom: 20px;
              &:last-child {
                margin-bottom: 0;
              }
              .module-item {
                display: inline-block;
                margin-right: 50px;
                img {
                  width: 220px;
                  height: 140px;
                }
                &:last-child {
                  margin-right: 0;
                }
              }
            }
          }
        }
      }

      // 关于我们
      .about-us {
        height: 672px;
        padding-top: 80px;
        .about-us-header {
          .about-us-title {
            font-size: 32px;
            color: #2E3032;
          }
        }
        .about-us-main {
          margin-top: 33px;
          color: #2E3032;
          .description {
            padding: 0 145px;
            margin-bottom: 30px;
          }
          .module-box {
            li {
              margin-bottom: 20px;
              &:last-child {
                margin-bottom: 0;
              }
              .module-item {
                display: inline-block;
                margin-right: 33px;
                img {
                  width: 320px;
                  height: 150px;
                  border: 1px dashed #ccc;
                }
                &:last-child {
                  margin-right: 0;
                }
              }
            }
          }
        }
      }
    }

    .footer {
      font-size: 14px;
      padding-top: 80px;
      .footer-main {
        padding: 33px 0 45px 0;
        height: 180px;
        background-color: #5C6064;
        display: flex;
        justify-content: center;
        // 公共
        .item-title {
          color: #fff;
          font-size: 14px;
          height: 20px;
          line-height: 20px;
          font-weight: normal;
        }
        .item-text {
          color: #B8C0C8;
        }
        .item-phone {
          color: #DDE7F0;
          margin-left: 5px;
        }
        .product {
          width: 100px;
          margin-right: 27px;
          a {
            text-decoration: none;
            color: #B8C0C8;
          }
        }
        .contact-us {
          min-width: 280px;
          margin-right: 40px;
          .work-date {
            margin-top: 5px;
            padding-left: 44px;
          }
        }
        .we-chat {
          width: 200px;
        }
      }
      .site-info {
        height: 53px;
        line-height: 53px;
        background-color: #2E3032;
        text-align: center;
        P {
          margin: 0;
          color: #8A9096;
          a {
            color: #8A9096;
            text-decoration: none;
          }
        }
      }
    }
  }

  /*主页结束*/
</style>



// WEBPACK FOOTER //
// src/views/pages/home.vue